import Vue from 'vue';
import Router from 'vue-router';

import Login from '../components/pages/Login';
import Authenticators from '../components/pages/Authenticators';
// import Settings from '../components/pages/Settings';
import Privacy from '../components/pages/Privacy';
import Disclaimer from '../components/pages/Disclaimer';
import Help from '../components/pages/Help';

import Settings from '../components/pages/SettingsList';
import AuthenticatorSettings from '@/components/pages/settings/AuthenticatorSettings';
import OfflineSettings from '@/components/pages/settings/OfflineSettings';

import AppInit from './guards/AppInit';
// import RedirectIfLoggedIn from './guards/RedirectIfLoggedIn';
import IsLoggedIn from './guards/IsLoggedIn';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'authenticators',
      component: Authenticators,
      beforeEnter: IsLoggedIn
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: IsLoggedIn,
    },
    {
      path: '/settings/authenticators',
      name: 'settings.authenticator',
      component: AuthenticatorSettings,
      beforeEnter: IsLoggedIn,
    },
    {
      path: '/settings/encrypted-offline-mode',
      name: 'settings.offline',
      component: OfflineSettings,
      beforeEnter: IsLoggedIn,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      // beforeEnter: RedirectIfLoggedIn
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: Privacy,
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: Disclaimer,
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
    },
  ]
});

router.beforeEach(AppInit);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js